export default '1.12.1';



// WEBPACK FOOTER //
// ./src/lib/version.js